<script>
  import Button from '@components/buttons/button.svelte'
  import { Info, CheckCircle, XCircle, CircleAlert, TriangleAlert } from 'lucide-svelte'
  import { cn } from '@lib/utils'
  
  let { title, message, type, class: className, children, fixed = false, showIcon = true, Icon, onClose } = $props()
    
  // let DerivedIcon = $derived(Icon || (type === 'info' ? Info : type === 'success' ? CheckCircle : XCircle))
  let DerivedIcon = $derived.by(() => {
    if (Icon) return Icon
    if (type === 'info') return Info
    if (type === 'success') return CheckCircle
    if (type === 'warning') return CircleAlert
    if (type === 'error') return TriangleAlert
  })

  let defaultClasses = $derived.by(() => {
    if (type === 'info') return 'bg-yellow-100 text-yellow-900'
    if (type === 'primary') return 'bg-primary-100 text-primary-900'
    if (type === 'success') return 'bg-green-100 text-green-900'
    if (type === 'warning') return 'bg-yellow-100 text-yellow-900'
    if (type === 'error') return 'bg-red-100 text-red-900'
    return 'text-gray-700 border border-gray-200/80'
  })
  
</script>

<div class={cn(defaultClasses, 'flex items-center gap-2 p-4 rounded-md text-smaller mb-6', fixed ? 'fixed top-3 left-1/2 -translate-x-1/2' : '', className)}>
  {#if showIcon}
    <DerivedIcon size={16} class="mt-0.5 shrink-0 mr-2" />
  {/if}
  <div class="flex-1 min-w-0">
    <div class="flex flex-col gap-1">
      {#if title}
        <h6 class="text-sm font-medium">{title}</h6>
      {/if}
      {#if children}
        {@render children()}
      {:else}
        <p class="text-smaller">{message}</p>
      {/if}
    </div>
  </div>
  {#if onClose}
    <Button variant="naked" class="shrink-0 self-start" title="Fermer" aria-label="Fermer" onclick={onClose}>
      <XCircle size={16} />
    </Button>
  {/if}
</div>